const types = {
    REQUEST_OTP: 'REQUEST_OTP',
    SEND_LOGIN: 'SEND_LOGIN',
    STORE_LOGIN: 'STORE_LOGIN',
    CHECK_TOKEN: 'CHECK_TOKEN',
    CHANGE_STATUS: 'CHANGE_STATUS',
    SEND_LOGOUT: 'SEND_LOGOUT',
    STORE_LOGOUT: 'STORE_LOGOUT',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    RECOVERY_PASSWORD: 'RECOVERY_PASSWORD',
    CHANGE_PASSWORD_MESSAGE: 'CHANGE_PASSWORD_MESSAGE',
    CLEAR_MESSAGES: 'CLEAR_MESSAGES',
    STORE_USER: 'STORE_USER'
}

export default types;

export const requestOTP = (usuario, clave) => {
    return { type: types.REQUEST_OTP, payload: { usuario, clave } };
}

export const sendLogin = (usuario, clave, otp) => {
    return { type: types.SEND_LOGIN, payload: { usuario, clave, otp } };
}

export const storeLogin = (response) => {
    return { type: types.STORE_LOGIN, payload: response };
}

export const checkToken = (token) => {
    return { type: types.CHECK_TOKEN, payload: { token } };
}

export const storeToken = (payload) => {
    return { type: types.CHANGE_STATUS, payload };
}

export const sendLogout = () => {
    return { type: types.SEND_LOGOUT };
}

export const changePassword = (values) => {
    return { type: types.CHANGE_PASSWORD, payload: { values } };
}

export const changeRecoveryPassword = (values) => {
    return { type: types.RECOVERY_PASSWORD, payload: { values } };
}

export const getStatusPasswordChange = (response) => {
    return { type: types.CHANGE_PASSWORD_MESSAGE, payload: { response } };
}

export const clearMessage = () => {
    return { type: types.CLEAR_MESSAGES };
}

export const storeUser = (user) => {
    return { type: types.STORE_USER, payload: { user } }
}
